module.exports = __webpack_public_path__ + "static/media/FreeSan-01.b28f4291.svg";